import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { DeliveryOutcome } from '../../../domain/entities/DeliveryDashboard';
import { OUTCOME_ICONS, OUTCOME_TAG_COLORS } from './deliveryOutcomeStyles';

const DeliveryOutcomeTag: React.FC<{ outcome: DeliveryOutcome }> = ({ outcome }) => {
  const { t } = useTranslation();

  return (
    <Tag icon={OUTCOME_ICONS[outcome]} color={OUTCOME_TAG_COLORS[outcome]}>
      {t(`delivery-outcome-${outcome}`, { ns: 'labels' })}
    </Tag>
  );
};

export default DeliveryOutcomeTag;
